import React from 'react';
import Routes from './routes';
import {Provider} from 'react-redux';
import './css/style.css';
import './css/font-awesome.css';
import './css/simple-line-icons.css';
import store from './store';

import {loadDriverRuns, Processing, processPendingActions} from './actions/runActions';
import ReduxToastr from 'react-redux-toastr';
import './assets/libs/bootstrap.min';
import { OidcProvider } from 'redux-oidc';
import userManager from './utils/userManager';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import {
    allowUserWithRoles,
    FullBaseUrl,
    IsInRole,
    ROLE_OfficeUser,
    ROLE_SalesManager,
    ROLE_SuperUser
} from "./constants";
import {loadUnmappedSuburbs} from "./actions/suburbActions";
import {loadUsers} from "./actions/userActions";
import {startTruckHub, subscribeToTruck} from "./utils/truckHub";
import {listPendingRequests} from './actions/clientRequestsActions';

//import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
//import {loadCourses} from './actions/courseActions';
//import {loadAccount} from './actions/accountActions';
//import {loadAuthors} from './actions/authorActions';

//const store = configureStore();

/*store.dispatch(loadCourses());
store.dispatch(loadAccount());
store.dispatch(loadAuthors()); */

//store.dispatch(loadRuns());
//store.dispatch(loadChecklists());

//processPendingActions();


setInterval(() =>  {
  if(!Processing){
    store.dispatch(processPendingActions());
  }
}, 1000);

//timer.setInterval(
setInterval(
  () => fetch(`${FullBaseUrl()}/index.html`).then(() => {
    store.dispatch(loadDriverRuns(false));
    store.dispatch(loadUnmappedSuburbs());
    store.dispatch(loadUsers());
    const account = store.getState().account;
    if(allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager])){
      store.dispatch(listPendingRequests({getTotal: true}));
    }
  }),
  1000 * 30
);

// Maintain the SignalR connection to the cloud truck-proxy hub and keep the active run's truck
// subscribed. Both calls are idempotent and only hit the network when state actually changes, so
// this replaces the old 2s wifi poll of the truck-proxy device.
setInterval(() => {
    const state = store.getState();
    const user = state.oidc && state.oidc.user;
    if (!user || !user.access_token) {
        return;
    }

    startTruckHub();

    const driverRuns = (state.driverRuns && state.driverRuns.items) || [];
    const activeRun =
        driverRuns.find(r => r.isCurrentUserDriver && r.isBaseCheckedIn && !r.isComplete)
        || (state.run && state.run.id ? state.run : null);

    if (activeRun && activeRun.truckNumberPlate) {
        subscribeToTruck(activeRun.truckNumberPlate);
    }
}, 5000);

const MainIndex = props => {
    return(
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <div>
          <Routes />
          <ReduxToastr
            timeOut={3000}
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
        </div>
      </OidcProvider>
    </Provider>
    );};
export default MainIndex;
